import { Component, OnInit, inject } from '@angular/core'
import { forkJoin, Observable, of, ReplaySubject } from 'rxjs'
import { catchError, map, skip, switchMap, take } from 'rxjs/operators'

import {
  CollectionData,
  CollectionService,
} from '../../../../../services/collection.service'
import {
  SearchStateInputs,
  SearchStateService,
} from '../../../../../services/search-state.service'
import { SearchUrlService } from '../../../../../services/search-url.service'

@Component({
  standalone: false,
  selector: 'cyborg-emerging',
  templateUrl: './emerging.component.html',
  styleUrls: ['./emerging.component.scss'],
})
export class EmergingComponent implements OnInit {
  private collectionService = inject(CollectionService)
  searchStateService = inject(SearchStateService)
  private searchUrlService = inject(SearchUrlService)

  public collections$: Observable<{
    emergingThreats: CollectionData[]
  }>
  public error$: ReplaySubject<Error> = new ReplaySubject(1)

  private HUNTER_GETTING_STARTED_COLLECTION =
    '26b3cb71-f9f0-499d-9d72-5b36ba1d1814'

  public async ngOnInit(): Promise<void> {
    this.collections$ = forkJoin({
      emergingThreats: this.collectionService
        .getEmergingThreatCollections()
        .pipe(
          map((collections) => {
            return collections.sort((collectionA, collectionB) => {
              return (
                new Date(collectionB.last_updated).valueOf() -
                new Date(collectionA.last_updated).valueOf()
              )
            })
          }),
          switchMap((collections) => {
            return forkJoin(
              collections.map(this.collectionService.resolveCollectionLinks),
            )
          }),
        ),
    }).pipe(
      catchError((error: Error) => {
        this.error$.next(error)
        return of(null)
      }),
    )
    this.bindSearchState()
  }

  /**
   * Listen for new state change from facet button tag clicks
   */
  private bindSearchState(): void {
    this.searchStateService.state
      .pipe(skip(1), take(1))
      .subscribe((state: SearchStateInputs) => {
        this.searchUrlService.gotoUrl(state)
      })
  }
}
